import { getCities } from '@homeservices/api-kit/search';

export default {
  namespaced: true,
  state () {
    return {
      zipcode: '',
      locations: [],
      selectedLocation: null,
    };
  },
  getters: {
    zipcode (state) {
      return state.zipcode;
    },
    locations (state) {
      return state.locations;
    },
    selectedLocation (state) {
      return state.selectedLocation;
    },
  },
  actions: {
    async getLocationByZipcode ({ commit }, { zipcode }) {
      const { data } = await getCities('US', zipcode);
      commit('updateLocations', data.results || []);
      return data;
    },
  },
  mutations: {
    resetLocations (state) {
      state.selectedLocation = null;
      state.zipcode = '';
      state.locations = [];
    },
    updateLocations (state, locations) {
      // spreading the inside objects
      state.locations = locations.map(location =>
        ({ ...location, ...location.geo_point, ...location.time_zone }));
      if (locations.length === 1) {
        [state.selectedLocation] = state.locations;
      }
    },
    selectedLocation (state, data) {
      state.selectedLocation = data;
    },
    updateZipcode (state, value) {
      state.zipcode = value;
    },
  },
};
